// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"bc93978a","71":"cb325fa3","440":"f86479c9","449":"31d41273","473":"4678eac6","482":"5b26ffe8","627":"e7160250","784":"f710ac48","887":"a6237301","927":"a189232f"}[chunkId] + ".chunk.js";
};